import { permissions } from '@mpk/shared/domain';

// TODO: PM - Might be moved to dashboard page later

/**
 * Permissions for conditions signing in contract management
 */
enum ConditionSigningPermissionsEnum {
  None = 0,

  /**
   * Conditions in contract-management can be viewed for signing
   * Konditionen im Vertragsmanagement können zur Zeichnung eingesehen werden
   */
  ViewConditions = 1,

  /**
   * Conditions in contract-management can be viewed for signing and signed
   * Konditionen im Vertragsmanagement können zur Zeichnung eingesehen und gezeichnet werden
   */
  ManageConditions = 2 | ViewConditions,
}

export const ConditionSigningPermissions = permissions(ConditionSigningPermissionsEnum, {
  featureId: 'ConditionSigning',
});
